<sirius-grid #catalogue>
  @if (searchQuery && (dataSource === 'urPlus' || dataSource === 'commerce')) {
    <div class="sir-search-container">
      <sirius-search
        tabindex="-1"
        [value]="searchQuery.query || ''"
        [busy]="updating.asObservable()"
        [rounded]="true"
        (submitEvent)="onSearch($event)"
        (clearEvent)="onSearch($event)">
      </sirius-search>
    </div>
  }
</sirius-grid>

<ng-content></ng-content>

<sirius-grid>
  @if (sorting) {
    <ng-container *ngTemplateOutlet="filterButton"></ng-container>
  }

  @if (filters && !filters.isEmpty()) {
    <sirius-filter
      [config]="filters.items"
      (selectionChange)="onFilter($event)"
      (activatedFilters)="onFiltersActivated($event)">
    </sirius-filter>
  }

  <div class="sir-catalogue-details sir-text-style-paragraph-m-default">
    @if (!sorting) {
      <ng-container *ngTemplateOutlet="filterButton"></ng-container>
    }
    @if (paging) {
      <div class="sir-paging-details">
        <p>
          <strong>{{ paging.totalItems }}</strong>
          <strong>
            {{ 'page.' + dataSource | translate }}
          </strong>
        </p>
        <div class="sir-page-size">
          <p>
            {{ 'page.showing' | translate }}
          </p>
          @for (size of paging.allowedSizes; track size) {
            <button
              type="button"
              class="sir-page-size-option"
              (click)="pageSize = size; update().subscribe()"
              [disabled]="size === paging.pageSize"
              [attr.aria-current]="size === paging.pageSize ? 'true' : null">
              {{ size }}
            </button>
          }
        </div>
      </div>
    }

    @if (sorting) {
      <div class="sir-sorting" data-cy="sorting">
        <button
          #sortingTrigger
          type="button"
          class="sir-sorting-control"
          [id]="sortingTriggerId"
          (click)="toggleSortingOptions($event)"
          (keydown)="onSortingTriggerKeydown($event, sortingTrigger)"
          [attr.aria-expanded]="showSortingOptions"
          [attr.aria-controls]="sortingDropdownId"
          aria-haspopup="listbox">
          <span class="sir-select-sorting">{{ 'button.sortBy' | translate }}</span>
          <span class="sir-sorting-text">
            {{ 'page.sortBy' | translate }}:
            <span class="sir-selected-label sir-text-style-paragraph-m-bold">{{ selectedSortingLabel }}</span>
          </span>
          @if (showSortingOptions) {
            <sirius-icon name="caret_up"></sirius-icon>
          } @else {
            <sirius-icon name="caret_down"></sirius-icon>
          }
        </button>
        @if (showSortingOptions) {
          <sirius-filter-dropdown
            #sortingDropdown
            [attr.id]="sortingDropdownId"
            [filterLabelId]="sortingTriggerId"
            (click)="$event.stopPropagation()"
            (selectionChange)="onSort()"
            (closeDropdown)="onSortingDropdownClose(sortingTrigger)"
            [values]="sorting.options"
            [multiSelect]="false">
          </sirius-filter-dropdown>
        }
      </div>
    }
  </div>
  <sirius-card-grid
    #cardGrid
    [items]="items"
    [cardSize]="'medium'"
    [dataSource]="dataSource"
  (selectEvent)="onSelect($event)"></sirius-card-grid>
  @if (paging && paging.numberOfPages > 1) {
    <sirius-pagination
      [config]="paging"
    (selectionChange)="onPaging($event)"></sirius-pagination>
  }
</sirius-grid>

@if (filters && mobileMenuOpen) {
  <sirius-filter-mobile
    [filters]="filters.items"
    (menuClose)="openMobileMenu(false)"
    (selectionChange)="onFilter($event)">
  </sirius-filter-mobile>
}

<ng-template #filterButton>
  @if (filters && !filters.isEmpty()) {
    <div class="sir-filter-button">
      <button
        siriusButton
        [iconName]="'sliders_horizontal_duotone'"
        [iconPos]="'left'"
        [buttonType]="'secondary'"
        [buttonText]="'button.filterList' | translate"
        (click)="openMobileMenu(true)">
        @if (filters.activeCount() > 0) {
          <sirius-badge [count]="filters.activeCount()"> </sirius-badge>
        }
      </button>
    </div>
  }
</ng-template>
<!-- <sirius-dimmer *ngIf="mobileMenuOpen"></sirius-dimmer> -->
